import React from 'react';

import { formatDuration } from '../../../../../utils/dateUtils';

interface TimelineProgressProps {
  maxCompletion?: number;
  delta?: number;
  timePeriod?: number;
  className?: string;
}

export function TimelineProgress({
  maxCompletion,
  delta,
  timePeriod,
  className = '',
}: TimelineProgressProps): JSX.Element {
  const getDeltaColor = (value: number): string => {
    if (value > 0) return 'text-green-600';
    if (value < 0) return 'text-red-600';
    return 'text-gray-500';
  };

  return (
    <span
      className={`text-xs text-gray-800 font-semibold flex items-center ${className}`}
    >
      {timePeriod ? (
        <>{formatDuration(timePeriod)}</>
      ) : (
        <>
          Progress: {maxCompletion}%
          <span
            className={`text-xs font-semibold ml-1 ${getDeltaColor(
              delta || 0,
            )}`}
          >
            ({delta && delta > 0 ? '+' : ''}
            {delta}%)
          </span>
        </>
      )}
    </span>
  );
}
